module.exports = __webpack_public_path__ + "static/AkzidenzGrotesk-Bold-700b7e875fd7d47b79ce5ff7cfb77f37.ttf";